import React, { FC } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { rules } from 'common/helpers/form.helper';
import { IFormValue } from 'common/models';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  onClose: () => void;
  onSave: (value: string, onSuccess: () => void) => void;
}

export const InventoryCreateAssigneeModal: FC<IComponentProps> = ({ open, loading, onClose, onSave }) => {
  const [form] = useForm();

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
    form.resetFields();
  };

  const onSubmit = ({ name }: IFormValue) => {
    onSave(name, handleClose);
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      centered
      open={open}
      onCancel={handleClose}
      destroyOnClose
      // @ts-ignore
      styles={{ mask: { zIndex: 1002 }, wrapper: { zIndex: 1003 } }}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleClose} loading={loading}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" loading={loading} onClick={form.submit}>
          Сохранить
        </Button>,
      ]}
    >
      <div className="ff-medium fs-m mt-6 mb-3">Добавить сотрудника</div>

      <div className="ff-regular fs-xs color-dark-grey mb-6">
        Созданный сотрудник будет отображаться только в вашем модуле учёта инструмента. Для добавления сотрудника в систему
        обратитесь к администратору.
      </div>

      <Form layout="vertical" requiredMark={false} form={form} onFinish={onSubmit}>
        <Form.Item label="ФИО*" name="name" rules={[rules.required()]}>
          <Input placeholder="Введите ФИО сотрудника" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
